import { render, staticRenderFns } from "./AddPreProduct.vue?vue&type=template&id=04df90f7&scoped=true"
import script from "./AddPreProduct.vue?vue&type=script&lang=js"
export * from "./AddPreProduct.vue?vue&type=script&lang=js"
import style0 from "./AddPreProduct.vue?vue&type=style&index=0&id=04df90f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04df90f7",
  null
  
)

export default component.exports